import React from 'react';

const Download = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.66675 10.6667L2.66675 11.3334C2.66675 12.4379 3.56218 13.3334 4.66675 13.3334L11.3334 13.3334C12.438 13.3334 13.3334 12.4379 13.3334 11.3334L13.3334 10.6667M10.6667 8.00004L8.00008 10.6667M8.00008 10.6667L5.33341 8.00004M8.00008 10.6667L8.00008 2.66671" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default Download;
